/* tslint:disable */
/* eslint-disable */
/**
 * driverPortal fleet-registration api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export interface RegisterRequest {
    hash?: string;
    ip?: string;
    password?: string;
    company_id?: string;
    terms_consent_accepted?: 0 | 1;
    whatsapp_opt_in?: 0 | 1;
    city_data?: string | null;
    currency?: string;
    other_city?: string;
    account_branch_code?: string;
    national_id?: string;
    preview_flow_id?: string;
    last_step: string;
    username?: string;
    email?: string | null;
    phone: string | null;
    first_name?: string | null;
    last_name?: string | null;
    city?: string | null;
    city_id?: string | null;
    birthday?: string | null;
    language?: string | null;
    referral_code?: string;
    has_car?: string;
    car_model_id?: string | null;
    model?: string;
    car_color?: string | null;
    car_transport_licence_number?: string | null;
    year?: string | null;
    license_plate?: string | null;
    normalized_license_plate?: string | null;
    vin?: string | null;
    personal_code?: string | null;
    driver_license?: string | null;
    has_taxi_license?: string;
    taxi_license?: string | null;
    type?: string | null;
    license_type_selection?: string | null;
    company_name?: string | null;
    address?: string | null;
    reg_code?: string | null;
    vat_code?: string | null;
    company_is_liable_to_vat?: 0 | 1;
    beneficiary_name?: string | null;
    iban?: string | null;
    swift?: string | null;
    allow_fleet_matching?: string;
}
